import { EventListenersManager } from "src/core/utilities";

export type LayoutEvents = {
  search: string;
};

class LayoutEventsListenersManager extends EventListenersManager<LayoutEvents> {}

export default new LayoutEventsListenersManager(["search"]);
